<template>
  <div :class="['login-link',{'header-link': header}]">
    <label v-on="$listeners">
      <slot></slot>
    </label>
  </div>
</template>

<script>
export default {
  name: "loginLink",
  props: ["header"]
};
</script>

<style scoped lang="scss">
.login-link {
  text-align: center;
  font-size: 0.94rem;
  color: $windows-blue-two-color;

  &.header-link{
    font-size: 1.1rem;
    letter-spacing: 0.4px;
  }
}
</style>
